import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const OficiulJuridic: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Oficiul Juridic
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Responsabil: Mariana Anastasiu
          </Typography>
          <Typography variant="body1">
            Oficiul Juridic se ocupă de aspectele legale ale eparhiei, 
            consultanță juridică și reprezentarea în procedurile legale.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OficiulJuridic;
